import React, {Component} from 'react';
import {Button, Form, Grid, Header, Dropdown, Image, Input, Modal, Popup, Segment,Table,Divider,Icon,TextArea,List} from 'semantic-ui-react';
import Loader from "../universal/loader";
import {getPriceLists,deleteList,updateList} from "../../data/price_list_api";
import html2canvas from 'html2canvas';
import {handleFileDownload} from "../../utils/download_file";

class CompanyPriceList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            priceListData:[],
            currentSelectedList:undefined,
            isLoading:true,
        }
    }

    componentWillMount() {this.refreshPriceLists()}


    refreshPriceLists = () =>{
      this.setState({isLoading:true,priceListData:[]})
      getPriceLists().then(res =>{this.setState({currentSelectedList:undefined,priceListData:res.priceData.sort((a, b) => a.name.localeCompare(b.name)),isLoading:false})})
    }

    saveList =(clearID = false) =>{
      this.setState({isLoading:true})
      if (this.state.currentSelectedList) {
        let listToUpdate = {...this.state.currentSelectedList}

        if (clearID) {
          listToUpdate.id = undefined
        }
        updateList(listToUpdate).then(()=>this.refreshPriceLists())
      }
    }

handlePaste = async (event, categoryName, furnishing) => {
  try {
    const pastedData = await navigator.clipboard.readText();

    // Split by newlines and filter empty rows
    const pastedCells = pastedData
      .split(/\r?\n/)
      .map(cell => cell.trim().replace("£", ""))
      .filter(cell => cell !== '');

    if (pastedCells.length !== 6) {
      window.alert(`You pasted ${pastedCells.length} cells. Please paste exactly 6 cells vertically.`);
      return;
    }

    let newPriceListData = { ...this.state.currentSelectedList };
    for (let i = 0; i < pastedCells.length; i++) {
      newPriceListData.prices[categoryName][furnishing][i] = pastedCells[i];
    }

    this.setState({ currentSelectedList: newPriceListData });
  } catch (err) {
    console.error("Failed to read clipboard", err);
  }
};

            handlePricelistImage = async () =>{
              html2canvas(document.querySelector("#listTable")).then(async canvas => {
            this.setState({isDownloading:true,showDownload:true});
            const fileName = `${this.state.currentSelectedList.name}.png`;
            await handleFileDownload(canvas.toDataURL('image/png'),fileName);
            this.setState({isDownloading:false});
        })
    }
    renderBulkEdit=(categoryName,furnishing)=>{
                     return   <Button onClick={(e)=>{this.handlePaste(e, categoryName,furnishing)}} basic compact>Bulk Edit</Button>}

    initializeNewList=() =>{
      let bedrooms = [0,0,0,0,0,0,0]
      let furnishings = {UN:[...bedrooms],
        PF:[...bedrooms],
        F:[...bedrooms]
      }
      let jobTypes = {CI:{...furnishings},INVCI:{...furnishings},CO:{...furnishings},INV:{...furnishings},XCO:{...furnishings}}
      let pricelist = {name:"NAME",price_type:"STANDARD",prices:{ABORT:0,PV:0,...jobTypes}, id:undefined}
      this.setState({currentSelectedList:JSON.parse(JSON.stringify(pricelist))})
    }
    renderTable(categoryName, data) {
      const labels = ["Studio", "1 Bed", "2 Bed", "3 Bed", "4 Bed", "5 Bed","6 Bed" ];

      return (
        <div key={categoryName} style={{ marginBottom: "2rem" }}>

          <Segment style={{margin:"auto",maxWidth:"60%"}}>
                  <Header as="h3">{categoryName}</Header>
          <Table textAlign='center' celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Type</Table.HeaderCell>
                {this.state.currentSelectedList.price_type !== "SINGLE" && (
                <Table.HeaderCell>Unfurnished {this.renderBulkEdit(categoryName,"UN")}</Table.HeaderCell>
                )}
                {this.state.currentSelectedList.price_type !== "NOPF" &&
                  this.state.currentSelectedList.price_type !== "SINGLE" && (
                    <Table.HeaderCell>Part Furnished {this.renderBulkEdit(categoryName,"PF")}</Table.HeaderCell>
                  )}
                                  <Table.HeaderCell>Furnished {this.renderBulkEdit(categoryName,"F")}</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {labels.map((label, index) => (
                <Table.Row key={index}>
                  <Table.Cell>{label}</Table.Cell>

                  {/* UN */}
                  {this.state.currentSelectedList.price_type !== "SINGLE" && (
                  <Table.Cell style={{textAlign:"center"}}>£
                          <Input  size="small"  
                          style={{maxWidth:"90px"}}
                          type="number"
                          value={this.state.currentSelectedList.prices[categoryName].UN[index]}
                          onChange={(e) => {
                            const updated = { ...this.state.currentSelectedList };
                            updated.prices[categoryName].UN[index] = Number(e.target.value);
                            this.setState({ currentSelectedList: updated });
                          }}
                        />
                    </Table.Cell>
                  )}   

                  {/* PF */}
                  {this.state.currentSelectedList.price_type !== "NOPF" &&
                    this.state.currentSelectedList.price_type !== "SINGLE" && (
                      <Table.Cell style={{textAlign:"center"}} >
                    £
                            <Input  size="small"  
                            style={{maxWidth:"90px"}}
                              type="number"
                              value={this.state.currentSelectedList.prices[categoryName].PF[index]}
                              onChange={(e) => {
                                const updated = { ...this.state.currentSelectedList };
                                updated.prices[categoryName].PF[index] = Number(e.target.value);
                                this.setState({ currentSelectedList: updated });
                              }}
                            />
                      </Table.Cell>
                    )}
                  {/* F */}
                  <Table.Cell style={{textAlign:"center"}}>
                  £
                        <Input size="small"   style={{maxWidth:"90px"}}
                          type="number"
                          value={this.state.currentSelectedList.prices[categoryName].F[index]}
                          onChange={(e) => {
                            const updated = { ...this.state.currentSelectedList };
                            updated.prices[categoryName].F[index] = Number(e.target.value);
                            this.setState({ currentSelectedList: updated });
                          }}
                        />
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
          </Segment>
        </div>
      );
    }


    render() {
          const listTypeOptions = [
    { key: "SINGLE", text: "SINGLE", value: "SINGLE" },
    { key: "NOPF", text: "NOPF", value: "NOPF" },
    { key: "STANDARD", text: "STANDARD", value: "STANDARD" },
  ];
        return (<Segment  className="pad-top">            
        <Header align="center">
            Price Lists
        </Header>
        {this.state.isLoading &&<Loader></Loader>}
        <Segment style={{margin:"auto",maxWidth:"60%"}}>
          <Button  compact onClick={()=>{this.initializeNewList()}}icon><Icon name="plus"></Icon>New</Button>
          {this.state.currentSelectedList && this.state.currentSelectedList.id && <Button compact onClick={()=>this.saveList()}>Update List</Button>}
          {this.state.currentSelectedList && <Button compact onClick={()=>this.saveList(true)}>Save as New List</Button>}
          {this.state.currentSelectedList && <Button compact  onClick={()=>this.handlePricelistImage()}>Download Image</Button>}
        </Segment>
        <div style={{maxHeight:"350px",overflowY:"auto"}}>
        <Table  style={{margin:"auto",maxWidth:"60%"}} celled compact size="small">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Name</Table.HeaderCell>
            <Table.HeaderCell>Price Type</Table.HeaderCell>
            <Table.HeaderCell>Actions</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {this.state.priceListData.map((client) => (
            <Table.Row
              key={client.id}
              active={client.id === this.state.currentSelectedList && this.state.currentSelectedList.id}
            >
              <Table.Cell>{client.name}</Table.Cell>
              <Table.Cell>{client.price_type}</Table.Cell>
              <Table.Cell>
                <Button compact basic primary onClick={() => this.setState({currentSelectedList:client})}>Edit</Button>
                <Popup on="click" position="top center" 
                trigger={<Button compact basic negative>Make Dormant</Button>} 
                content={ <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}> <div>Are you sure?</div> <Button negative size="small" style={{ marginTop: '5px' }} onClick={() => deleteList(client.id).then(()=>this.refreshPriceLists())} > Yes, Make Dormant </Button> </div> } />
                  <Popup
                    position="right center"
                    trigger={
                      <Button color="orange" compact basic>
                        {client.companies.length} Companies
                      </Button>
                    }
                    content={
                      client.companies.length > 0 ? (
                        <List divided relaxed>
                          {client.companies.slice() // make a shallow copy to avoid mutating original array
                            .sort((a, b) =>
                              a.name.localeCompare(b.name, undefined, { sensitivity: 'base' })
                            ).map((company) => (
                            <List.Item key={company.id}>
                              <List.Content>
                                <List.Header>{company.name}</List.Header>
                              </List.Content>
                            </List.Item>
                          ))}
                        </List>
                      ) : (
                        <p>No companies assigned</p>
                      )
                    }
                  />
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
      </div>
      <Divider></Divider>

      {/* //SLECTED LIST LOGIC */}
      {this.state.currentSelectedList && (
          <Segment id="listTable">
          <div>
      {/* List Type */}
       <Segment style={{margin:"auto",maxWidth:"60%"}}>
              <Input size="small"   label="List Name"
                value={this.state.currentSelectedList.name}
                onChange={(e) => {
                  const updated = { ...this.state.currentSelectedList };
                  updated.name = e.target.value;
                  this.setState({ currentSelectedList: updated });
                }}
              />
                    <hr/>
                    <Button>List Type</Button>
                    <Input  size="small"  label="Price Type"  labelPosition="left"  type="text"  >
              <Dropdown size="small"  selection  options={listTypeOptions}  value={this.state.currentSelectedList.price_type} onChange={(e, { value }) => {  
                const  updated = { ...this.state.currentSelectedList };
                  updated.price_type = value;
                  this.setState({ currentSelectedList: updated });
                }}
              />
            </Input>


      {/* ABORT */}
      <hr/>
              <Input label="Abort Price"
                type="number"
                size="small"  
                value={this.state.currentSelectedList.prices.ABORT}
                onChange={(e) => {
                  const updated = { ...this.state.currentSelectedList };
                  updated.prices.ABORT = Number(e.target.value);
                  this.setState({ currentSelectedList: updated });
                }}
              />
            <hr/>
                          <Input label="PV Price"
                type="number"
                size="small"  
                value={this.state.currentSelectedList.prices.PV}
                onChange={(e) => {
                  const updated = { ...this.state.currentSelectedList };
                  updated.prices.PV = Number(e.target.value);
                  this.setState({ currentSelectedList: updated });
                }}
              />
            <hr/>
            <Form>
              <Form.TextArea
                label="Notes"
                value={this.state.currentSelectedList.notes || ""}
                onChange={(e, { value }) => {
                  const updated = { ...this.state.currentSelectedList };
                  updated.notes = value;
                  this.setState({ currentSelectedList: updated });
                }}
              />
            </Form>
           </Segment>
        </div>

            {/* START OF PRICE SECTION */}
            {/* INV Table */}
            {this.state.currentSelectedList.prices.INV &&
              this.renderTable(
                "INV",
                this.state.currentSelectedList.prices.INV
              )}

            {/* INVCI Table */}
            {this.state.currentSelectedList.prices.INVCI &&
              this.renderTable(
                "INVCI",
                this.state.currentSelectedList.prices.INVCI
              )}
            {/* CI Table */}
            {this.state.currentSelectedList.prices.CI &&
              this.renderTable(
                "CI",
                this.state.currentSelectedList.prices.CI
              )}

            {/* CO Table */}
            {this.state.currentSelectedList.prices.CO &&
              this.renderTable(
                "CO",
                this.state.currentSelectedList.prices.CO
              )}

          </Segment>
        )}
        </Segment>
        )
}

}

export default (CompanyPriceList);


// WEBPACK FOOTER //
// ./src/views/company/price_list.js